/* eslint-disable */
// @ts-ignore

import { z } from 'zod';
import { OrganizationId } from './organization.interface';

export const UserIdSchema = z.string().brand('UserId');
export type UserId = z.infer<typeof UserIdSchema> | string;

// @ts-ignore - We're force overwriting the type here
declare module '@supabase/supabase-js' {

    export interface AuthUser {
        // @ts-ignore - We're force overwriting the type here
        id: UserId;
    }
}

/**
 * Interface for user data
 */
export interface IUser {
    id: UserId;
    fullName?: string;
    firstName?: string;
    lastName?: string;
    avatarUrl?: string;
    defaultOrganizationId?: OrganizationId;
    /**
     * The Featurebase identity verification hash for this user
     */
    featurebaseIdentityVerificationHash?: string;
}
